import { render, staticRenderFns } from "./add.vue?vue&type=template&id=b54225e8&scoped=true"
import script from "./add.js?vue&type=script&lang=js&external"
export * from "./add.js?vue&type=script&lang=js&external"
import style0 from "./add.vue?vue&type=style&index=0&id=b54225e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54225e8",
  null
  
)

export default component.exports